import { render, staticRenderFns } from "./PageTitle3.vue?vue&type=template&id=4f6b7238&"
import script from "./PageTitle3.vue?vue&type=script&lang=js&"
export * from "./PageTitle3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports